import _ from "lodash";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { Field, reduxForm, SubmissionError } from "redux-form";
import Button from "react-bootstrap-button-loader";
import {
  openInterestModal,
  addUserInterests,
  updateUserInterest,
  editInterest,
} from "ActionsMessage";
import { isEmpty } from "BaseFunctions";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE, MAX_INTEREST_COUNT } from "Constants";
import InterestCell from "./interest-cell.js";
import LocaleStrings from "Languages";

class AddInterests extends Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.state = {
      loading: false,
      canbeDeleted: true,
      interests: props.interests,
      deletedInterests: [],
      updateInterests: [],
      initialLoad: true,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      if (this.state.initialLoad && nextProps.showModal === true) {
        if (nextProps.interests.length > 0)
          this.setState({
            initialLoad: false,
            canbeDeleted: nextProps.interests.length > 1,
          });
      }
    }
  }

  open() {
    this.props.openInterestModal(true);
  }

  close() {
    this.props.openInterestModal(false);
    this.props.reset();
    this.setState({
      loading: false,
      interests: [],
      deletedInterests: [],
      updateInterests: [],
      initialLoad: true,
    });
    this.props.editInterest({});
  }

  onFormSubmit = (values) => {
    values.interest = values.interest.trim();
    if (this.props.toEdit) {
      if (this.props.toUpdateFromInside) {
        var arrInterests = this.state.interests;
        //var itemToUpdate=arrInterests.filter((interest)=>interest.interestid === values.interestid);
        var index = _.findIndex(arrInterests, function (interest) {
          return interest.interestid === values.interestid;
        });
        arrInterests[index].interest = values.interest;
        if (!arrInterests[index].islocal) arrInterests[index].toupdate = true; //flag to patch in backend api
        this.setState({ interests: arrInterests });
        this.props.editInterest({});
        this.props.reset();
      } else {
        /*var updateInterests=[values,...this.state.updateInterests];
        this.setState({updateInterests});*/

        //Call api and directly update
        this.props.updateUserInterest(
          this.props.session,
          values,
          (result) => {
            this.props.showSuccess(
              LocaleStrings.message_interest_form_update_success
            );
            this.close();
            this.props.reset();
          },
          (error) => {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
        );
      }
    } else {
      var interests = [...this.state.interests];
      var previousInterest = interests.filter(
        (interest) => interest.interest === values.interest
      );
      if (previousInterest.length > 0) {
        throw new SubmissionError({
          interest: LocaleStrings.message_interest_form_error_exists,
          _error: "Failed",
        });
      } else {
        interests.push({
          interestid: `ID${interests.length}`,
          interest: values.interest,
          islocal: true,
        });
        this.setState({ interests });
        this.props.reset();

        if (interests.length > 1) {
          this.setState({ canbeDeleted: true });
        }
      }
    }
  };

  onSaveInterests = () => {
    //debugger;
    if (this.state.interests.length == 0) {
      this.props.showError(LocaleStrings.message_interest_form_error_min1);
      return false;
    }
    this.setState({ loading: true });

    var arrData = this.state.interests;
    var arrToDelete = this.state.deletedInterests;
    if (arrToDelete.length > 0) {
      arrData = [...arrData, ...arrToDelete];
    }

    var arrDataToSend = [];
    //Pickout data which are local that will be added, or data to be updated or, deleted, other should be rejected
    arrData.map((interest, index) => {
      if (interest.islocal) {
        arrDataToSend.push(interest);
      } else if (interest.toupdate) {
        arrDataToSend.push(interest);
      } else if (interest.todelete) {
        arrDataToSend.push(interest);
      }
    });

    this.props.addUserInterests(
      this.props.session,
      arrDataToSend,
      (response) => {
        if (response.success == 1) {
          this.props.showSuccess(
            LocaleStrings.message_interest_form_add_success
          );
          this.close();
        } else {
          this.props.showSuccess(COMMON_FAIL_MESSAGE);
        }
        this.setState({ loading: false });
      }
    );
  };

  onDeleteInterest = (item) => {
    var totalCount = this.state.interests.length;

    var filteredInterests = this.state.interests.filter(
      (interest) => interest.interestid !== item.interestid
    );
    this.setState({ interests: filteredInterests });

    if (!item.islocal) {
      var deletedInterests = this.state.deletedInterests;
      deletedInterests = [{ ...item, todelete: true }, ...deletedInterests];
      var deletedCount = deletedInterests.length;

      this.setState({ deletedInterests });
    }

    var canbeDeleted = true;
    // if((totalCount-deletedCount)>=1)
    if (filteredInterests.length > 1) canbeDeleted = true;
    else canbeDeleted = false;

    this.setState({ canbeDeleted });
  };

  onEditInterest = (item) => {
    this.props.editInterest(item);
  };

  cancelEdit = () => {
    this.props.editInterest({});
    this.props.reset();
  };

  renderCustomTextField(field) {
    var labelposition = field.labelposition;
    var formdiv = "";
    if (field.formdiv !== undefined && field.formdiv === "false") {
      formdiv = "";
    }
    var divClassName = `form-group row ${formdiv} ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0 mb-8";

    return (
      <div className={divClassName}>
        {field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
          <div className="interest-subtitle-info">
            {LocaleStrings.message_interest_note}
          </div>
        </div>
        <div className="col-md-12">
          {field.maxLimitReached ? null : (
            <Button
              className="btn btn-custom-blue"
              type="submit"
              disabled={field.buttonDisabled}
            >
              {field.toEdit
                ? LocaleStrings.button_update
                : LocaleStrings.button_add}
            </Button>
          )}
          {field.toEdit ? (
            <Button
              className="btn btn-custom-white ml-10"
              onClick={
                field.toUpdateFromInside
                  ? field.onCancelEdit
                  : field.onCloseEdit
              }
            >
              {LocaleStrings.button_cancel}
            </Button>
          ) : null}
        </div>
      </div>
    );
  }

  renderInterestList = () => {
    return this.state.interests.map((interest, id) => {
      return (
        <InterestCell
          key={id}
          interest={interest}
          canbeDeleted={this.state.canbeDeleted}
          onDelete={this.onDeleteInterest}
          onEdit={this.onEditInterest}
        />
      );
    });
  };

  render() {
    var { handleSubmit, invalid, pristine, submitting, toEdit } = this.props;
    var maxLimitReached = this.state.interests.length === MAX_INTEREST_COUNT;
    if (toEdit) maxLimitReached = false;

    return (
      <Modal
        className="modal-container"
        show={this.props.showModal === true ? true : false}
        onHide={this.close}
        animation={true}
        keyboard={false}
        backdrop="static"
      >
        <Modal.Header>
          <div className="import-modal-title">
            {toEdit
              ? LocaleStrings.message_interest_form_modal_title_edit
              : LocaleStrings.message_interest_form_modal_title_add}
          </div>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={() => this.close()}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div>
            {maxLimitReached ? (
              <div className="interest-subtitle-info">
                {LocaleStrings.message_interest_subtitle_info2}
              </div>
            ) : (
              <form onSubmit={handleSubmit(this.onFormSubmit)}>
                <Field
                  name="interest"
                  label={LocaleStrings.message_eventags}
                  placeholder={LocaleStrings.message_placeholder_eventags}
                  type="text"
                  mandatory="true"
                  component={this.renderCustomTextField}
                  buttonDisabled={pristine || invalid || submitting}
                  maxLimitReached={maxLimitReached}
                  toEdit={toEdit}
                  onCancelEdit={this.cancelEdit}
                  toUpdateFromInside={this.props.toUpdateFromInside}
                  onCloseEdit={this.close}
                />
              </form>
            )}
            {toEdit ? null : this.state.interests.length > 0 ? (
              <div className="imported-users h-381px">
                <table className="table">
                  <thead>
                    <tr>
                      <th>{LocaleStrings.message_eventags}</th>
                      <th className="text-right">
                        {LocaleStrings.message_action}
                      </th>
                    </tr>
                  </thead>
                  <tbody>{this.renderInterestList()}</tbody>
                </table>
              </div>
            ) : null}
          </div>
        </Modal.Body>
        {toEdit ? (
          <Modal.Footer>
            <Button className="btn btn-custom-white" onClick={this.close}>
              {LocaleStrings.message_closebutton}
            </Button>
          </Modal.Footer>
        ) : (
          <Modal.Footer>
            <Button className="btn btn-custom-white" onClick={this.close}>
              {LocaleStrings.message_closebutton}
            </Button>
            <Button
              className="btn btn-custom-blue ml-10"
              disabled={
                this.state.interests.length === 0 &&
                this.state.deletedInterests.length === 0
              }
              onClick={this.onSaveInterests}
              loading={this.state.loading}
            >
              {LocaleStrings.message_savebutton}
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var toEdit = !isEmpty(state.editInterest);
  var values = { interest: "" };
  if (toEdit) values = state.editInterest;

  if (!toEdit) {
    toEdit = !isEmpty(state.interestModal.interest);
    if (toEdit) values = state.interestModal.interest;
  }

  return {
    session: state.session,
    showModal: state.interestModal.status,
    interests: state.interests,
    toEdit,
    initialValues: values,
    toUpdateFromInside: state.editInterest.updateFromInside,
  };
}

function validate(values) {
  var errors = {};

  if (!values.interest) {
    errors.interest = "Please input Event Tags!";
  }

  if (values.interest) {
    var invalid =
      values.interest === null || values.interest.match(/^ *$/) !== null;
    if (invalid) {
      errors.interest = "Please input Event Tags!";
    }
  }

  return errors;
}

export default connect(mapStateToProps, {
  addUserInterests,
  openInterestModal,
  updateUserInterest,
  editInterest,
  showError,
  showSuccess,
})(
  reduxForm({
    form: "AddUserInterestForm",
    validate,
    enableReinitialize: true,
  })(AddInterests)
);
